'use es6';

import { parse } from 'hub-http/helpers/params';
import { useLocation } from 'react-router-dom';
export const _getQueryParamFromLocation = ({
  paramKey,
  location
}) => {
  let queryParam;

  if (location) {
    const query = parse(location.search.slice(1));

    if (query) {
      if (query[paramKey]) {
        queryParam = decodeURIComponent(query[paramKey]);
      } else if (query[paramKey.toLowerCase()]) {
        // shortlinks will lowercase passthrough query params so we have to check both
        queryParam = decodeURIComponent(query[paramKey.toLowerCase()]);
      }
    }
  }

  return queryParam;
};
export const useQueryParamFromLocation = paramKey => {
  return _getQueryParamFromLocation({
    paramKey,
    location: useLocation()
  });
};